import $ from 'jquery';
 
export default() => {
    (function (AllCollections, $) {
        'use strict';

        AllCollections.init = function () {
            $('body').on('click touchstart', '[data-target]', function () {
                var type = document.getElementById(this.dataset.type);
                var $image = $(this).closest('[data-all-collection]').find('[data-collection-image]');
                $(this).closest('[data-all-collection]').find('[data-target]').removeClass('font-bold');
                $(this).addClass('font-bold');
                $image.fadeOut();
                $(type).find('[data-collection]').hide();
                $(type).find('[data-collection=' + this.dataset.target + ']').show();
                $image.fadeIn();
            });
        };

        if (document.getElementById('shopify-section-all-collections')) {

            AllCollections.init();
        }
    })(window.AllCollections = window.AllCollections || {}, $);
};